
/**
 * Compute the user's "streak day" as YYYY-MM-DD in their timezone with cutoff.
 * Uses same Intl.DateTimeFormat style as utils.js.
 */
export function streakDate(now = new Date(), timeZone = 'Europe/London', cutoffHour = 0) {
  // Break down "now" into local parts in the given TZ
  const fmt = new Intl.DateTimeFormat('en-GB', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  });
  const parts = Object.fromEntries(fmt.formatToParts(now).map(p => [p.type, p.value]));
  const y = Number(parts.year);
  const m = Number(parts.month);
  const d = Number(parts.day);
  const hh = Number(parts.hour);
  const mm = Number(parts.minute);
  const ss = Number(parts.second);

  // Local "zoned" Date
  const zonedNow = new Date(Date.UTC(y, m - 1, d, hh, mm, ss));

  // Apply cutoff by shifting backwards
  zonedNow.setUTCHours(zonedNow.getUTCHours() - (cutoffHour || 0));

  const yy = zonedNow.getUTCFullYear();
  const mm2 = String(zonedNow.getUTCMonth() + 1).padStart(2, '0');
  const dd2 = String(zonedNow.getUTCDate()).padStart(2, '0');

  return `${yy}-${mm2}-${dd2}`;
}

/**
 * Update streak fields in a Firestore transaction.
 * Ensures idempotency (won't double-count if already credited today).
 */
export function updateStreakInTx(tx, userRef, data, now = new Date()) {
  const tz = data.streak_timezone || 'Europe/London';
  const cutoff = typeof data.streak_cutoff_hour === 'number' ? data.streak_cutoff_hour : 0;

  const today = streakDate(now, tz, cutoff);
  const last = data.last_streak_date || null;
  const count = data.streak_count || 0;
  const longest = data.longest_streak || 0;

  let newCount = 1;
  if (!last) {
    newCount = 1;
  } else if (last === today) {
    newCount = count; // already credited today
  } else {
    const lastDate = new Date(last + 'T00:00:00Z');
    const nextDate = new Date(lastDate);
    nextDate.setUTCDate(nextDate.getUTCDate() + 1);
    const isoNext = nextDate.toISOString().slice(0, 10);
    newCount = (isoNext === today) ? count + 1 : 1;
  }

  if (last !== today) {
    tx.set(userRef, {
      streak_count: newCount,
      longest_streak: Math.max(longest, newCount),
      last_streak_date: today,
    }, { merge: true });
  }

  return { streak_count: newCount, longest_streak: Math.max(longest, newCount), last_streak_date: today };
}

